// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legal-structures-template_pageHeader__8tuyq h2 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 16px;
}

.legal-structures-template_tableOuter__v78cw {
    page-break-after: always;
    page-break-inside: avoid;
}

.legal-structures-template_tableOuter__v78cw * {
    transition: none !important;
}

.legal-structures-template_table__yRr5B {
    display: flex;
    flex-wrap: wrap;
    min-width: 100%;
}

.legal-structures-template_table__yRr5B td {
    min-width: 50px;
    vertical-align: middle;
}

.legal-structures-template_table__yRr5B table thead th {
    font-weight: 500;
    color: #000;
}

.legal-structures-template_table__yRr5B div > table {
    min-width: 100%;
}

/*.tableOuter:not(.tableSecondary)*/
/*    .table*/
/*    > div:first-child:not(:last-child)*/
/*    > div*/
/*    > table*/
/*    > thead*/
/*    > tr*/
/*    > th:nth-child(6)*/
/*    ~ th,*/
/*.tableOuter:not(.tableSecondary)*/
/*    .table*/
/*    > div:first-child:not(:last-child)*/
/*    > div*/
/*    > table*/
/*    > tbody*/
/*    > tr*/
/*    > td:nth-child(6)*/
/*    ~ td,*/
/*.tableOuter.tableSecondary .table > div:first-child:not(:last-child) > div > table > thead > tr > th:nth-child(5) ~ th,*/
/*.tableOuter.tableSecondary .table > div:first-child:not(:last-child) > div > table > tbody > tr > td:nth-child(5) ~ td,*/
/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > tbody > tr > td:first-child,*/
/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > thead > tr > th:first-child {*/
/*    display: none !important;*/
/*}*/

/*.table > div:last-child:not(:first-child) > div > table > thead > tr > th:not(:first-child),*/
/*.table > div:last-child:not(:first-child) > div > table > tbody > tr > td:not(:first-child) {*/
/*    display: none !important;*/
/*}*/

/*.tableOuter:not(.tableSecondary)*/
/*    .table*/
/*    > div:last-child:not(:first-child)*/
/*    > div*/
/*    > table*/
/*    > thead*/
/*    > tr*/
/*    > th:nth-child(6)*/
/*    ~ th,*/
/*.tableOuter:not(.tableSecondary)*/
/*    .table*/
/*    > div:last-child:not(:first-child)*/
/*    > div*/
/*    > table*/
/*    > tbody*/
/*    > tr*/
/*    > td:nth-child(6)*/
/*    ~ td,*/
/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > thead > tr > th:nth-child(5) ~ th,*/
/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > tbody > tr > td:nth-child(5) ~ td {*/
/*    display: table-cell !important;*/
/*}*/

.legal-structures-template_tableOuter__v78cw:not(.legal-structures-template_tableSecondary__SS1Qm)
    .legal-structures-template_table__yRr5B
    > div:first-child:not(:last-child)
    > div
    > table
    > tbody
    > tr
    > td:nth-child(6):after,
.legal-structures-template_tableOuter__v78cw.legal-structures-template_tableSecondary__SS1Qm
    .legal-structures-template_table__yRr5B
    > div:first-child:not(:last-child)
    > div
    > table
    > tbody
    > tr
    > td:nth-child(5):after {
    width: calc(100% - 10px) !important;
}

.legal-structures-template_table__yRr5B div > table > tbody > tr,
.legal-structures-template_table__yRr5B div > table > tbody > tr {
    position: relative;
}

.legal-structures-template_table__yRr5B div > table > tbody > tr > td:after,
.legal-structures-template_table__yRr5B div > table > tbody > tr > td:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    border-bottom: 1px solid var(--light-grey);
    pointer-events: none;
    z-index: 6;
}

.legal-structures-template_table__yRr5B tr {
    vertical-align: top;
}

.legal-structures-template_table__yRr5B table {
    width: 100%;
    border-collapse: collapse;
}

.legal-structures-template_table__yRr5B table table thead th:after {
    display: none;
}

.legal-structures-template_table__yRr5B th {
    position: relative;
}

.legal-structures-template_table__yRr5B thead th {
    z-index: 12;
}

.legal-structures-template_table__yRr5B thead th {
    padding: 5px 10px;
    position: relative;
    transition: color 0.4s;
}

.legal-structures-template_table__yRr5B thead th:first-child {
    z-index: 14;
    position: sticky;
    left: 0;
    top: 0;
    background: #fbfbfb;
    transition:
        color 0.4s,
        background-color 0.4s;
}

.legal-structures-template_table__yRr5B table thead th:after {
    content: '';
    position: absolute;
    display: block;
    width: calc(100% - 20px);
    top: 100%;
    left: 10px;
    border-bottom: 1px solid #7b848e;
    z-index: 12;
    transition: border-color 0.4s;
}

.legal-structures-template_table__yRr5B table thead th:first-child:after {
    width: calc(100% - 10px);
    left: 0;
}

.legal-structures-template_table__yRr5B table thead th:last-child:after {
    width: calc(100% - 10px);
}

.legal-structures-template_table__yRr5B table > tbody > tr > td:first-child,
.legal-structures-template_table__yRr5B td {
    padding: 10px 2px;
    font-weight: 400;
    text-align: center;
}

.legal-structures-template_tableOuter__v78cw:not(.legal-structures-template_tableSecondary__SS1Qm) .legal-structures-template_table__yRr5B:not(.legal-structures-template_fixed__KnwlB) div > table > tbody > tr > td:first-child {
    width: 150px;
    max-width: 150px;
    position: relative;
}

.legal-structures-template_table__yRr5B > div > table > tbody > tr > td:first-child img {
    margin-top: 10px;
}

.legal-structures-template_tableOuter__v78cw .legal-structures-template_table__yRr5B div > table > tbody > tr > td:first-child img {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LegalStructuresTemplate/legal-structures-template.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA,mCAAmC;AACnC,aAAa;AACb,yCAAyC;AACzC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,WAAW;AACX,wBAAwB;AACxB,YAAY;AACZ,mCAAmC;AACnC,aAAa;AACb,yCAAyC;AACzC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,WAAW;AACX,wBAAwB;AACxB,YAAY;AACZ,0HAA0H;AAC1H,0HAA0H;AAC1H,oHAAoH;AACpH,qHAAqH;AACrH,gCAAgC;AAChC,IAAI;;AAEJ,+FAA+F;AAC/F,gGAAgG;AAChG,gCAAgC;AAChC,IAAI;;AAEJ,mCAAmC;AACnC,aAAa;AACb,yCAAyC;AACzC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,WAAW;AACX,wBAAwB;AACxB,YAAY;AACZ,mCAAmC;AACnC,aAAa;AACb,yCAAyC;AACzC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,WAAW;AACX,wBAAwB;AACxB,YAAY;AACZ,0HAA0H;AAC1H,2HAA2H;AAC3H,sCAAsC;AACtC,IAAI;;AAEJ;;;;;;;;;;;;;;;;IAgBI,mCAAmC;AACvC;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,WAAW;IACX,0CAA0C;IAC1C,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,OAAO;IACP,MAAM;IACN,mBAAmB;IACnB;;6BAEyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,SAAS;IACT,UAAU;IACV,gCAAgC;IAChC,WAAW;IACX,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;IACxB,OAAO;AACX;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".pageHeader h2 {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 16px;\n}\n\n.tableOuter {\n    page-break-after: always;\n    page-break-inside: avoid;\n}\n\n.tableOuter * {\n    transition: none !important;\n}\n\n.table {\n    display: flex;\n    flex-wrap: wrap;\n    min-width: 100%;\n}\n\n.table td {\n    min-width: 50px;\n    vertical-align: middle;\n}\n\n.table table thead th {\n    font-weight: 500;\n    color: #000;\n}\n\n.table div > table {\n    min-width: 100%;\n}\n\n/*.tableOuter:not(.tableSecondary)*/\n/*    .table*/\n/*    > div:first-child:not(:last-child)*/\n/*    > div*/\n/*    > table*/\n/*    > thead*/\n/*    > tr*/\n/*    > th:nth-child(6)*/\n/*    ~ th,*/\n/*.tableOuter:not(.tableSecondary)*/\n/*    .table*/\n/*    > div:first-child:not(:last-child)*/\n/*    > div*/\n/*    > table*/\n/*    > tbody*/\n/*    > tr*/\n/*    > td:nth-child(6)*/\n/*    ~ td,*/\n/*.tableOuter.tableSecondary .table > div:first-child:not(:last-child) > div > table > thead > tr > th:nth-child(5) ~ th,*/\n/*.tableOuter.tableSecondary .table > div:first-child:not(:last-child) > div > table > tbody > tr > td:nth-child(5) ~ td,*/\n/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > tbody > tr > td:first-child,*/\n/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > thead > tr > th:first-child {*/\n/*    display: none !important;*/\n/*}*/\n\n/*.table > div:last-child:not(:first-child) > div > table > thead > tr > th:not(:first-child),*/\n/*.table > div:last-child:not(:first-child) > div > table > tbody > tr > td:not(:first-child) {*/\n/*    display: none !important;*/\n/*}*/\n\n/*.tableOuter:not(.tableSecondary)*/\n/*    .table*/\n/*    > div:last-child:not(:first-child)*/\n/*    > div*/\n/*    > table*/\n/*    > thead*/\n/*    > tr*/\n/*    > th:nth-child(6)*/\n/*    ~ th,*/\n/*.tableOuter:not(.tableSecondary)*/\n/*    .table*/\n/*    > div:last-child:not(:first-child)*/\n/*    > div*/\n/*    > table*/\n/*    > tbody*/\n/*    > tr*/\n/*    > td:nth-child(6)*/\n/*    ~ td,*/\n/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > thead > tr > th:nth-child(5) ~ th,*/\n/*.tableOuter.tableSecondary .table > div:last-child:not(:first-child) > div > table > tbody > tr > td:nth-child(5) ~ td {*/\n/*    display: table-cell !important;*/\n/*}*/\n\n.tableOuter:not(.tableSecondary)\n    .table\n    > div:first-child:not(:last-child)\n    > div\n    > table\n    > tbody\n    > tr\n    > td:nth-child(6):after,\n.tableOuter.tableSecondary\n    .table\n    > div:first-child:not(:last-child)\n    > div\n    > table\n    > tbody\n    > tr\n    > td:nth-child(5):after {\n    width: calc(100% - 10px) !important;\n}\n\n.table div > table > tbody > tr,\n.table div > table > tbody > tr {\n    position: relative;\n}\n\n.table div > table > tbody > tr > td:after,\n.table div > table > tbody > tr > td:after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    border-bottom: 1px solid var(--light-grey);\n    pointer-events: none;\n    z-index: 6;\n}\n\n.table tr {\n    vertical-align: top;\n}\n\n.table table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.table table table thead th:after {\n    display: none;\n}\n\n.table th {\n    position: relative;\n}\n\n.table thead th {\n    z-index: 12;\n}\n\n.table thead th {\n    padding: 5px 10px;\n    position: relative;\n    transition: color 0.4s;\n}\n\n.table thead th:first-child {\n    z-index: 14;\n    position: sticky;\n    left: 0;\n    top: 0;\n    background: #fbfbfb;\n    transition:\n        color 0.4s,\n        background-color 0.4s;\n}\n\n.table table thead th:after {\n    content: '';\n    position: absolute;\n    display: block;\n    width: calc(100% - 20px);\n    top: 100%;\n    left: 10px;\n    border-bottom: 1px solid #7b848e;\n    z-index: 12;\n    transition: border-color 0.4s;\n}\n\n.table table thead th:first-child:after {\n    width: calc(100% - 10px);\n    left: 0;\n}\n\n.table table thead th:last-child:after {\n    width: calc(100% - 10px);\n}\n\n.table table > tbody > tr > td:first-child,\n.table td {\n    padding: 10px 2px;\n    font-weight: 400;\n    text-align: center;\n}\n\n.tableOuter:not(.tableSecondary) .table:not(.fixed) div > table > tbody > tr > td:first-child {\n    width: 150px;\n    max-width: 150px;\n    position: relative;\n}\n\n.table > div > table > tbody > tr > td:first-child img {\n    margin-top: 10px;\n}\n\n.tableOuter .table div > table > tbody > tr > td:first-child img {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `legal-structures-template_pageHeader__8tuyq`,
	"tableOuter": `legal-structures-template_tableOuter__v78cw`,
	"table": `legal-structures-template_table__yRr5B`,
	"tableSecondary": `legal-structures-template_tableSecondary__SS1Qm`,
	"fixed": `legal-structures-template_fixed__KnwlB`
};
export default ___CSS_LOADER_EXPORT___;
